import React, { useState } from "react";
import styles from "./Customer.module.css";
import { closeInvestingAccount } from "../../api";
import Modal from "../../Common/ClosureModal/Modal";
import CommentModal from "../../Common/CommentModal/commentModal";

const AccountClosure = ({
  data,
  custId,
  refreshDetails,
  isEditable,
  listStatus,
}) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleInitializeClose = () => {
    setShowConfirmationModal(true);
  };

  const handleCloseConfirmation = () => {
    setShowConfirmationModal(false);
  };

  const handleConfirmYes = () => {
    setShowConfirmationModal(false);
    setShowCommentModal(true);
  };

  const handleCloseCommentModal = () => {
    setShowCommentModal(false);
    setComment("");
    setError("");
    setSuccessMessage("");
    setErrorMessage("");
  };

  const handleCloseAccount = async () => {
    if (!comment.trim()) {
      setError("Please enter a comment.");
      return;
    }
    setLoading(true);
    setError("");
    setErrorMessage("");
    try {
      const resp = await closeInvestingAccount(custId, { comment });
      if (resp?.code === 200) {
        setSuccessMessage("Account closed successfully!");
        if (refreshDetails) {
          await refreshDetails();
        }
        setTimeout(() => {
          handleCloseCommentModal();
        }, 2000);
      } else {
        setErrorMessage(resp?.data?.message || "Failed to close account");
      }
    } catch (err) {
      setErrorMessage(
        err?.response?.data?.message || "Something went wrong. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: "30px" }}>
      <div className={styles.detailContainer}>
        <div className={styles.text}>Account Closure</div>
      </div>
      {listStatus === "CLOSED" || data?.accountStatus === "CLOSED" ? (
        <div className={styles.closedMessage}>
          This account is already closed.
        </div>
      ) : (
        isEditable && (
          <div className={styles.closeButton}>
            <button
              className={styles.closeAccountButton}
              onClick={handleInitializeClose}
            >
              Close Account
            </button>
          </div>
        )
      )}

      <Modal
        isOpen={showConfirmationModal}
        onRequestClose={handleCloseConfirmation}
        title="Account Closure"
        description="This is a permanent and irreversible action. Please confirm before proceeding."
        onNo={handleCloseConfirmation}
        onYes={handleConfirmYes}
      />

      <CommentModal
        isOpen={showCommentModal}
        onRequestClose={handleCloseCommentModal}
        comment={comment}
        setComment={setComment}
        error={error}
        setError={setError}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
        onSave={handleCloseAccount}
        loading={loading}
        modalTitle="Close Account"
        setIsComment={setComment}
      />
    </div>
  );
};

export default AccountClosure;
